export var todayOrders = {
  labels: [
    "12AM - 02AM",
    "02AM - 04AM",
    "04AM - 06AM",
    "06AM - 08AM",
    "08AM - 10AM",
    "10AM - 12PM",
    "12PM - 02PM",
    "02PM - 04PM",
    "04PM - 06PM",
    "06PM - 08PM",
    "08PM - 10PM",
    "10PM - 12PM",
  ],
  dataUnit: "Orders",
  lineTension: 0.3,
  datasets: [
    {
      label: "Orders",
      color: "#854fff",
      borderWidth: 2,
      borderColor: "#854fff",
      lineTension: 0.3,
      pointBorderColor: "transparent",
      pointBackgroundColor: "transparent",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "#854fff",
      pointBorderWidth: 2,
      pointHoverRadius: 4,
      pointHoverBorderWidth: 2,
      pointRadius: 4,
      pointHitRadius: 4,
      backgroundColor: "transparent",
      data: [92, 105, 125, 85, 110, 106, 131, 105, 110, 131, 105, 110],
    },
  ],
};

export var todayRevenue = {
  labels: [
    "12AM - 02AM",
    "02AM - 04AM",
    "04AM - 06AM",
    "06AM - 08AM",
    "08AM - 10AM",
    "10AM - 12PM",
    "12PM - 02PM",
    "02PM - 04PM",
    "04PM - 06PM",
    "06PM - 08PM",
    "08PM - 10PM",
    "10PM - 12PM",
  ],
  dataUnit: "Orders",
  lineTension: 0.3,
  datasets: [
    {
      label: "Revenue",
      color: "#33d895",
      borderWidth: 2,
      borderColor: "#33d895",
      lineTension: 0.3,
      pointBorderColor: "transparent",
      pointBackgroundColor: "transparent",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "#33d895",
      pointBorderWidth: 2,
      pointHoverRadius: 4,
      pointHoverBorderWidth: 2,
      pointRadius: 4,
      pointHitRadius: 4,
      backgroundColor: "transparent",
      data: [92, 105, 125, 85, 110, 106, 131, 105, 110, 131, 105, 110],
    },
  ],
};

export var todayCustomers = {
  labels: [
    "12AM - 02AM",
    "02AM - 04AM",
    "04AM - 06AM",
    "06AM - 08AM",
    "08AM - 10AM",
    "10AM - 12PM",
    "12PM - 02PM",
    "02PM - 04PM",
    "04PM - 06PM",
    "06PM - 08PM",
    "08PM - 10PM",
    "10PM - 12PM",
  ],
  dataUnit: "Orders",
  lineTension: 0.3,
  datasets: [
    {
      label: "Customers",
      color: "#ff63a5",
      borderWidth: 2,
      borderColor: "#ff63a5",
      lineTension: 0.3,
      pointBorderColor: "transparent",
      pointBackgroundColor: "transparent",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "#ff63a5",
      pointBorderWidth: 2,
      pointHoverRadius: 4,
      pointHoverBorderWidth: 2,
      pointRadius: 4,
      pointHitRadius: 4,
      backgroundColor: "transparent",
      data: [92, 105, 125, 85, 110, 106, 131, 105, 110, 131, 105, 110],
    },
  ],
};

export var todayVisitors = {
  labels: [
    "12AM - 02AM",
    "02AM - 04AM",
    "04AM - 06AM",
    "06AM - 08AM",
    "08AM - 10AM",
    "10AM - 12PM",
    "12PM - 02PM",
    "02PM - 04PM",
    "04PM - 06PM",
    "06PM - 08PM",
    "08PM - 10PM",
    "10PM - 12PM",
  ],
  dataUnit: "Orders",
  lineTension: 0.3,
  datasets: [
    {
      label: "Visitors",
      color: "#559bfb",
      borderWidth: 2,
      borderColor: "#559bfb",
      lineTension: 0.3,
      pointBorderColor: "transparent",
      pointBackgroundColor: "transparent",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "#559bfb",
      pointBorderWidth: 2,
      pointHoverRadius: 4,
      pointHoverBorderWidth: 2,
      pointRadius: 4,
      pointHitRadius: 4,
      backgroundColor: "transparent",
      data: [92, 105, 125, 85, 110, 106, 131, 105, 110, 131, 105, 110],
    },
  ],
};

export var salesStatistics = {
  labels: [
    "01 Jan",
    "02 Jan",
    "03 Jan",
    "04 Jan",
    "05 Jan",
    "06 Jan",
    "07 Jan",
    "08 Jan",
    "09 Jan",
    "10 Jan",
    "11 Jan",
    "12 Jan",
    "13 Jan",
    "14 Jan",
    "15 Jan",
    "16 Jan",
    "17 Jan",
    "18 Jan",
    "19 Jan",
    "20 Jan",
    "21 Jan",
    "22 Jan",
    "23 Jan",
    "24 Jan",
    "25 Jan",
    "26 Jan",
    "27 Jan",
    "28 Jan",
    "29 Jan",
    "30 Jan",
  ],
  dataUnit: "People",
  datasets: [
    {
      label: "Total orders",
      color: "#0fac81",
      borderWidth: 2,
      borderColor: "#0fac81",
      fill: true,
      dash: 0,
      pointRadius: 0,
      lineTension: 0.4,
      backgroundColor: "rgba(15, 172, 129, 0.15)",
      pointBorderColor: "transparent",
      pointBackgroundColor: "transparent",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "#0fac81",
      pointBorderWidth: 2,
      pointHoverRadius: 4,
      pointHoverBorderWidth: 2,
      pointHitRadius: 4,
      data: [
        3710, 4820, 4810, 5480, 5300, 5670, 6660, 4830, 5590, 5730, 4790, 4950, 5100, 5800, 5950, 5850, 5950, 4450,
        4900, 8000, 7200, 7250, 7900, 8950, 6300, 7200, 7250, 7650, 6950, 4750,
      ],
    },
    {
      label: "Canceled orders",
      color: "#eb6459",
      borderWidth: 2,
      borderColor: "#eb6459",
      borderDash: [5],
      pointBorderColor: "transparent",
      pointBackgroundColor: "transparent",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "#eb6459",
      pointBorderWidth: 2,
      pointHoverRadius: 4,
      pointHoverBorderWidth: 2,
      pointHitRadius: 4,
      data: [
        110, 220, 810, 480, 600, 670, 660, 830, 590, 730, 790, 950, 100, 800, 950, 850, 950, 450, 900, 0, 200, 250, 900,
        950, 300, 200, 250, 650, 950, 750,
      ],
    },
  ],
};

export var salesStatisticsSet2 = {
  labels: [
    "01 Jan",
    "02 Jan",
    "03 Jan",
    "04 Jan",
    "05 Jan",
    "06 Jan",
    "07 Jan",
    "08 Jan",
    "09 Jan",
    "10 Jan",
    "11 Jan",
    "12 Jan",
    "13 Jan",
    "14 Jan",
    "15 Jan",
    "16 Jan",
    "17 Jan",
    "18 Jan",
    "19 Jan",
    "20 Jan",
    "21 Jan",
    "22 Jan",
    "23 Jan",
    "24 Jan",
    "25 Jan",
    "26 Jan",
    "27 Jan",
    "28 Jan",
    "29 Jan",
    "30 Jan",
  ],
  dataUnit: "People",
  datasets: [
    {
      label: "Total orders",
      color: "#0fac81",
      borderWidth: 2,
      borderColor: "#0fac81",
      fill: true,
      dash: 0,
      pointRadius: 0,
      lineTension: 0.4,
      backgroundColor: "rgba(15, 172, 129, 0.15)",
      pointBorderColor: "transparent",
      pointBackgroundColor: "transparent",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "#0fac81",
      pointBorderWidth: 2,
      pointHoverRadius: 4,
      pointHoverBorderWidth: 2,
      pointHitRadius: 4,
      data: [
        2710, 2820, 2810, 3480, 4300, 2670, 4660, 5830, 2590, 1730, 4790, 6950, 1100, 2800, 2950, 4850, 3950, 3450,
        7900, 3000, 4200, 5250, 9900, 5950, 6300, 7200, 7250, 7650, 6950, 4750,
      ],
    },
    {
      label: "Canceled orders",
      color: "#eb6459",
      borderWidth: 2,
      borderColor: "#eb6459",
      borderDash: [5],
      backgroundColor: "transparent",
      pointBorderColor: "transparent",
      pointBackgroundColor: "transparent",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "#eb6459",
      pointBorderWidth: 2,
      pointHoverRadius: 4,
      pointHoverBorderWidth: 2,
      pointHitRadius: 4,
      data: [
        60, 220, 510, 180, 900, 1270, 560, 1030, 1590, 1730, 390, 450, 1000, 900, 950, 850, 950, 450, 900, 0, 200, 250,
        900, 950, 300, 200, 250, 650, 950, 750,
      ],
    },
  ],
};

export var salesStatisticsSet3 = {
  labels: [
    "01 Jan",
    "02 Jan",
    "03 Jan",
    "04 Jan",
    "05 Jan",
    "06 Jan",
    "07 Jan",
    "08 Jan",
    "09 Jan",
    "10 Jan",
    "11 Jan",
    "12 Jan",
    "13 Jan",
    "14 Jan",
    "15 Jan",
    "16 Jan",
    "17 Jan",
    "18 Jan",
    "19 Jan",
    "20 Jan",
    "21 Jan",
    "22 Jan",
    "23 Jan",
    "24 Jan",
    "25 Jan",
    "26 Jan",
    "27 Jan",
    "28 Jan",
    "29 Jan",
    "30 Jan",
  ],
  dataUnit: "People",
  datasets: [
    {
      label: "Total orders",
      color: "#0fac81",
      borderWidth: 2,
      borderColor: "#0fac81",
      fill: true,
      dash: 0,
      pointRadius: 0,
      lineTension: 0.4,
      backgroundColor: "rgba(15, 172, 129, 0.15)",
      pointBorderColor: "transparent",
      pointBackgroundColor: "transparent",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "#0fac81",
      pointBorderWidth: 2,
      pointHoverRadius: 4,
      pointHoverBorderWidth: 2,
      pointHitRadius: 4,
      data: [
        5710, 2820, 3810, 8480, 5300, 1670, 8660, 8830, 5590, 2730, 3790, 5950, 1000, 7800, 6950, 6850, 5950, 2450,
        4900, 5000, 4200, 9250, 5900, 4950, 6300, 7200, 7250, 7650, 6950, 4750,
      ],
    },
    {
      label: "Canceled orders",
      color: "#eb6459",
      borderWidth: 2,
      borderColor: "#eb6459",
      borderDash: [5],
      pointRadius: 0,
      backgroundColor: "transparent",
      pointBorderColor: "transparent",
      pointBackgroundColor: "transparent",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "#eb6459",
      pointBorderWidth: 2,
      pointHoverRadius: 4,
      pointHoverBorderWidth: 2,
      pointHitRadius: 4,
      data: [
        120, 50, 510, 280, 600, 670, 260, 230, 890, 1730, 2090, 1550, 1000, 1800, 950, 850, 950, 450, 900, 0, 200, 500,
        950, 1950, 1300, 1200, 1250, 250, 2950, 750,
      ],
    },
  ],
};

export var salesStatisticsSet4 = {
  labels: [
    "01 Jan",
    "02 Jan",
    "03 Jan",
    "04 Jan",
    "05 Jan",
    "06 Jan",
    "07 Jan",
    "08 Jan",
    "09 Jan",
    "10 Jan",
    "11 Jan",
    "12 Jan",
    "13 Jan",
    "14 Jan",
    "15 Jan",
    "16 Jan",
    "17 Jan",
    "18 Jan",
    "19 Jan",
    "20 Jan",
    "21 Jan",
    "22 Jan",
    "23 Jan",
    "24 Jan",
    "25 Jan",
    "26 Jan",
    "27 Jan",
    "28 Jan",
    "29 Jan",
    "30 Jan",
  ],
  dataUnit: "People",
  datasets: [
    {
      label: "Total orders",
      color: "#0fac81",
      borderWidth: 2,
      borderColor: "#0fac81",
      fill: true,
      dash: 0,
      pointRadius: 0,
      lineTension: 0.4,
      backgroundColor: "rgba(15, 172, 129, 0.15)",
      pointBorderColor: "transparent",
      pointBackgroundColor: "transparent",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "#0fac81",
      pointBorderWidth: 2,
      pointHoverRadius: 4,
      pointHoverBorderWidth: 2,
      pointHitRadius: 4,
      data: [
        2710, 1820, 6810, 8480, 7300, 7670, 6660, 8830, 5590, 2730, 3790, 5950, 7000, 7800, 6950, 6850, 5950, 2450,
        6900, 5000, 4200, 9250, 5900, 4950, 8300, 8200, 8250, 8650, 5950, 6750,
      ],
    },
    {
      label: "Canceled orders",
      color: "#eb6459",
      borderWidth: 2,
      borderColor: "#eb6459",
      borderDash: [5],
      pointRadius: 0,
      backgroundColor: "transparent",
      pointBorderColor: "transparent",
      pointBackgroundColor: "transparent",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "#eb6459",
      pointBorderWidth: 2,
      pointHoverRadius: 4,
      pointHoverBorderWidth: 2,
      pointHitRadius: 4,
      data: [
        1000, 1550, 1510, 1280, 1600, 1670, 1260, 1230, 1890, 1730, 2090, 1550, 1000, 1800, 1950, 1150, 1950, 1450,
        1900, 1000, 1200, 1500, 1950, 1950, 1300, 1200, 1250, 1250, 2950, 1750,
      ],
    },
  ],
};

export var orderStatistics = {
  labels: ["Completed", "Processing", "Canclled"],
  dataUnit: "People",
  legend: false,
  datasets: [
    {
      borderColor: "#fff",
      backgroundColor: ["#0fac81", "#e85347", "#816bff"],
      data: [4305, 859, 482],
    },
  ],
};
